/**
 * LoginHS 업무 셸의 전역 검색 배치 정책.
 *
 * PROVE/관세율표 검색은 페이지별 필터와 역할이 다르므로 로그인 후 업무 화면
 * 전역에서 같은 위치와 크기로 유지한다. 홈은 동일한 CenterSearchBar를 히어로에
 * 이미 제공하므로 헤더에는 하나 더 만들지 않는다.
 */

const HEADER_SEARCH_EXCLUDED_ROUTES = new Set(["home"]);

export function shouldShowHeaderSearch({ isLoginHS, auditRoute }) {
  if (!isLoginHS || !auditRoute) return false;
  return !HEADER_SEARCH_EXCLUDED_ROUTES.has(auditRoute);
}

// 가운데 플로팅 검색바 — 헤더 top 검색이 없는 화면(standalone)에서만, 데스크톱 브라우징 시.
export function shouldShowFloatingSearch({ isMobile, hasQuery, hasHeaderSearch }) {
  if (hasHeaderSearch) return false; // 앱 셸: 상단 검색이 담당 → 플로팅 숨김(1개 불변식)
  return !isMobile && !hasQuery;
}
